import { render, staticRenderFns } from "./VaccinationAnalysisChartBody.vue?vue&type=template&id=6f6f7646&"
import script from "./VaccinationAnalysisChartBody.vue?vue&type=script&lang=ts&"
export * from "./VaccinationAnalysisChartBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports